import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SwipeToDelete from 'react-swipe-to-delete-ios';
import SectionTitle from '../../components/SectionTitle';
import { Button } from '@/components/ui/button';
import QuotesService from '@/common/API/QuotesService';
import BookPlaceholder from '@/components/BookPlaceholder';
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from '@/components/ui/carousel';
import { ArrowRightIcon } from '@radix-ui/react-icons';
import Utils from '@/common/Utils';

const QuotesPreview = () => {
  const [quotesList, setQuotesList] = useState([]);

  useEffect(() => {
    QuotesService.all({
      page: 1,
      per_page: 7,
    }).then((res: any) => {
      console.log(res.data);
      setQuotesList(res?.data);
    });
  }, []);
  return (
    <article className='mt-5'>
      <div className='flex justify-between items-center mb-2'>
        <SectionTitle className='text-white' label='Quotes' />
        {/* <Button asChild className='text-xs' size='sm' variant='ghost'>
          <Link to='/quotes'>View more</Link>
        </Button> */}
      </div>
      <Carousel>
        <CarouselContent>
          {quotesList.map((quote: any) => {
            return (
              <CarouselItem key={quote?.id} className='basis-3/4 '>
                <article key={quote.text} className='mr-2 cursor-pointer bg-card text-white rounded-lg'>
                  <div className='p-4 h-[100px]'>
                    <span className='text-xs text-neutral-700'>Quote </span>

                    <div className='line-clamp-2 w-full'>{Utils.htmlToText(quote.text)}</div>
                  </div>
                  <div className='w-full h-[1px] border border-neutral-800 border-dashed'></div>
                  <div className='text-xs text-neutral-700 p-4 flex items-center justify-between'>
                    <div>
                      <span>Book: </span>
                      <span className='inline-block mr-5 text-neutral-500'>{quote?.book?.name}</span>
                    </div>

                    <span className=' ml-auto bg-primary text-secondary px-2 py-1 rounded-full text-white'>
                      {quote?.tag?.name}
                    </span>
                  </div>
                </article>
              </CarouselItem>
            );
          })}
          <CarouselItem key='books-more' className='basis-1/3 flex items-center'>
            <Button variant='ghost' className='rounded-full w-12 h-12'>
              <Link to='/books'>
                <ArrowRightIcon className='text-xl font-bold' />
              </Link>
            </Button>
          </CarouselItem>
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
      </Carousel>
    </article>
  );
};

export default QuotesPreview;
